import { createSelector } from 'reselect';

const selectCache = (state: any) => state.alertsCache;

export const selectAlertsData = createSelector(
  selectCache,
  (cache) => cache.data
);
